import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import { useAppSelector } from 'shared/hooks';

import Item from './Item';

import './TableBalance.scss';
import sortSVG from './img/sort.svg';
import SVG from 'components/SVG';

const b = block('balance-table-desktop');

const TableBalance = ({ data, type, setIsAsc, isAsc }) => {
  const locale = useAppSelector(state => state.locale.locale, shallowEqual);

  const itemsElements = useMemo(
    () =>
      data?.map((t, i) => (
        <div key={t.number} className={b('item')}>
          <Item item={t} type={type} />
        </div>
      )),
    [data, type],
  );

  const headerClass = type === 'players' ? b('header', { 'six-columns': true }) : b('header', { 'four-columns': true });

  return (
    <div className={b()}>
      <div className={headerClass}>
        <div className={b('header-item')}>{locale.id}</div>
        <div className={b('header-item')}>{locale.username}</div>
        {/*<div className={b('header-item')}>{locale.agent}</div>*/}
        <div className={b('header-item')}>{locale.actualBalance}</div>
        <div className={b('header-item')}>{locale.balanceBefore}</div>
        <div className={b('header-item')}>{locale.balanceAfter}</div>
        <div className={b('header-item')}>
          <span>{locale.changeBalance}</span>
          <button className={b('change-balance-button')} onClick={() => setIsAsc(ps => !ps)}>
            <SVG
              containerClassName={b('change-balance-button-icon', {
                asc: isAsc,
              })}
              svgProps={{
                svg: sortSVG,
              }}
            />
          </button>
        </div>
      </div>
      {itemsElements?.length ? itemsElements : <div className={b('empty')}>{locale.noResultsFound}</div>}
    </div>
  );
};

export default TableBalance;
